import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import Login from './Login.vue';
import FWLLoader from './components/loader.vue';
import FWLSelectLanguage from './components/selectLanguage.vue';
import FWLModalErrorUnauthorized from './modalErrorUnauthorized.vue';

// Get initial language from localStorage or browser
let language = {};
try {
    language = localStorage.getItem("language")
        ? JSON.parse(localStorage.getItem("language"))
        : {
            acronym: navigator.language.substring(0, 2) || navigator.userLanguage.substring(0, 2) || "es",
            dictionaryId: navigator.language.substring(0, 2) || navigator.userLanguage.substring(0, 2) || "es"
        };
} catch (ex) {
    language = {
        acronym: navigator.language.substring(0, 2) || navigator.userLanguage.substring(0, 2) || "es",
        dictionaryId: navigator.language.substring(0, 2) || navigator.userLanguage.substring(0, 2) || "es"
    };
}

// Configure i18n
const i18n = createI18n({
    legacy: true,
    locale: language.acronym,
    fallbackLocale: language.acronym,
    messages: {
        [language.acronym]: {} // Empty initially, will be loaded by component
    },
    globalInjection: true
});

// Create and configure app
const app = createApp(Login);

app.use(i18n);

// Register global components
app.component("fwl-preloader", FWLLoader);
app.component("fwl-select-language", FWLSelectLanguage);
app.component("fwl-modal-error-unauthorized", FWLModalErrorUnauthorized);

// Mount the app
app.mount('#login');